import { useEffect } from 'react';
import { Loader2, Phone } from 'lucide-react';
import { trackEvent } from '@/utils/trackingClient';
import { trackLead } from '@/lib/tracking';

const TEL_URL = 'tel:+4917620283482';

const CallRedirect = () => {
  useEffect(() => {
    let redirected = false;
    const doRedirect = () => {
      if (redirected) return;
      redirected = true;
      window.location.replace(TEL_URL);
    };

    trackLead('anruf', null);
    trackEvent('call_click', {
      event_type: 'click',
      destination_url: TEL_URL,
      timeoutMs: 500,
    }).finally(doRedirect);

    const safety = setTimeout(doRedirect, 800);
    return () => clearTimeout(safety);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBF9F5] px-4">
      <div className="flex items-center gap-2 mb-3">
        <Phone className="w-6 h-6 text-[#4A331D]" />
        <Loader2 className="w-6 h-6 animate-spin text-[#4A331D]" />
      </div>
      <p className="text-sm text-gray-600" data-testid="call-redirect">Anruf wird vorbereitet…</p>
      <a href={TEL_URL} className="mt-3 text-xs text-[#4A331D] underline" data-testid="call-fallback-link">
        Falls nichts passiert: hier klicken
      </a>
    </div>
  );
};

export default CallRedirect;
